import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {CenteredSpinnerComponent} from './components/centered-spinner/centered-spinner.component';
import { TopLoadingBarComponent } from './components/top-loading-bar/top-loading-bar.component';
import {FormUtilities} from './FormUtilities';
import { ToolBarComponent } from './components/tool-bar/tool-bar.component';
import { TitleComponent } from './components/title/title.component';
import {ThemeTriangleComponent} from './components/theme-triangle/theme-triangle.component';
import {AddItemDialogComponent} from './components/add-item-dialog/add-item-dialog.component';
import {DeleteItemDialogComponent} from './components/delete-item-dialog/delete-item-dialog.component';
import {RestoreItemDialogComponent} from './components/restore-item-dialog/restore-item-dialog.component';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {AddItemComponent} from './components/add-item/add-item.component';
import {DataGridComponent} from './components/data-grid/data-grid.component';
import {SearchFieldComponent} from './components/search-field/search-field.component';
import {SmallSpinnerComponent} from './components/small-spinner/small-spinner.component';
import {FloatingLabelComponent} from './components/floating-label/floating-label.component';
import {EditItemService} from './services/edit-item/edit-item.service';
import {DeleteItemService} from './services/delete-item/delete-item.service';
import {RestoreItemService} from './services/restore-item/restore-item.service';
import {HttpClientModule} from '@angular/common/http';
import {HttpClient} from './services/http-client/http-client.service';
import {HttpModule} from '@angular/http';
import {RedirectService} from './services/redirect/redirect.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ObjectMapService} from './services/object-map/object-map.service';
import { DataGridColumnFilterComponent } from './components/data-grid-column-filter/data-grid-column-filter.component';
import {StringUtilities} from './StringUtilities';
import { ColumnSortService } from './services/column-sort/column-sort.service';
import { CloneContractDialogComponent } from './components/clone-contract-dialog/clone-contract-dialog.component';
import {CloneContractService} from './services/clone-contract/clone-contract.service';
import { FailedDeleteItemDialogComponent } from './components/failed-delete-item-dialog/failed-delete-item-dialog.component';
import { BreadcrumbService } from './services/breadcrumb/breadcrumb.service';
import {RouterModule} from '@angular/router';
import {AirlineNameResolverService} from '../airline/resolvers/airline-name-resolver.service';
import {ContractNameResolverService} from '../contract/resolvers/contract-name-resolver.service';
import { RouteLoaderComponent } from './components/route-loader/route-loader.component';
import {BreadCrumbAndDataHelperService} from './services/route-resolvers/bread-crumb-and-data-helper.service';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { ErrorService } from './services/error/error.service';
import { ExceptionPhotosComponent } from './components/exception-photos/exception-photos.component';
import {ExceptionPhotosService} from './services/exception-photos/exception-photos.service';
import { ExceptionImageComponent } from './components/exception-image/exception-image.component';
import {RequestSupportDialogComponent} from './components/request-support-dialog/request-support-dialog.component';
import {RequestSupportButtonComponent} from './components/request-support/request-support-button.component';
import {RequestSupportService} from './services/request-support/request-support.service';
import {ConfirmationDialogComponent} from './components/confirmation-dialog/confirmation-dialog.component';
import {ConfirmationDialogService} from './services/confirmation-dialog/confirmation-dialog.service';
import {ExceptionDialogComponent} from './components/exception-dialog/exception-dialog.component';
import {MultiselectDropdownComponent} from './components/multiselect-dropdown/multiselect-dropdown.component';
import {ReportDialogComponent} from './components/report-dialog/report-dialog.component';

@NgModule({
  imports: [
    HttpClientModule,
    HttpModule,
    MaterialModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    RouterModule
  ],
  declarations: [
    CenteredSpinnerComponent,
    FloatingLabelComponent,
    TopLoadingBarComponent,
    ToolBarComponent,
    TitleComponent,
    ThemeTriangleComponent,
    AddItemDialogComponent,
    ExceptionDialogComponent,
    DeleteItemDialogComponent,
    RestoreItemDialogComponent,
    AddItemComponent,
    RequestSupportDialogComponent,
    ConfirmationDialogComponent,
    RequestSupportButtonComponent,
    DataGridComponent,
    SearchFieldComponent,
    SmallSpinnerComponent,
    DataGridColumnFilterComponent,
    CloneContractDialogComponent,
    FailedDeleteItemDialogComponent,
    RouteLoaderComponent,
    ErrorDialogComponent,
    ExceptionPhotosComponent,
    ExceptionImageComponent,
    MultiselectDropdownComponent,
    ReportDialogComponent
  ],
  entryComponents: [
    AddItemDialogComponent,
    ExceptionDialogComponent,
    RequestSupportDialogComponent,
    ConfirmationDialogComponent,
    DeleteItemDialogComponent,
    RestoreItemDialogComponent,
    CloneContractDialogComponent,
    FailedDeleteItemDialogComponent,
    RouteLoaderComponent,
    ErrorDialogComponent,
    ReportDialogComponent
  ],
  providers: [
    FormUtilities,
    EditItemService,
    DeleteItemService,
    RestoreItemService,
    HttpClient,
    RedirectService,
    ObjectMapService,
    StringUtilities,
    ColumnSortService,
    CloneContractService,
    BreadcrumbService,
    AirlineNameResolverService,
    ContractNameResolverService,
    BreadCrumbAndDataHelperService,
    ErrorService,
    ExceptionPhotosService,
    RequestSupportService,
    ConfirmationDialogService
  ],
  exports: [
    CenteredSpinnerComponent,
    ConfirmationDialogComponent,
    SmallSpinnerComponent,
    FloatingLabelComponent,
    RequestSupportDialogComponent,
    RequestSupportButtonComponent,
    TopLoadingBarComponent,
    ToolBarComponent,
    TitleComponent,
    ThemeTriangleComponent,
    AddItemComponent,
    DataGridComponent,

    // dialogs
    AddItemDialogComponent,
    DeleteItemDialogComponent,
    RestoreItemDialogComponent,
    ExceptionDialogComponent,

    SearchFieldComponent,
    FailedDeleteItemDialogComponent,
    MultiselectDropdownComponent,
    ReportDialogComponent
  ]
})
export class UtilitiesModule {}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/utilities.module.ts